import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import KeyMetrics from './components/KeyMetrics';
import AboutAurion from './components/AboutAurion';
import Solutions from './components/Solutions';
import Sectors from './components/Sectors';
import Method from './components/Method';
import WhyAurion from './components/WhyAurion';
import NewsMarket from './components/NewsMarket';
import MainOffer from './components/MainOffer';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <AboutAurion />
        <Solutions />
        <Sectors />
        <Method />
        <WhyAurion />
        <KeyMetrics />
        <TrustBar />
        <NewsMarket />
        <MainOffer />
      </main>
      <Footer />
    </div>
  );
}
